
export const DOKA_EDITOR_LABELS = {
  labelButtonCropFlipHorizontal: global.Translator.trans(
    "imageEditEditor.labelButtonCropFlipHorizontal",
    {},
    "js"
  ),
  labelButtonCropFlipVertical: global.Translator.trans(
    "imageEditEditor.labelButtonCropFlipVertical",
    {},
    "js"
  ),
  labelColorContrast: global.Translator.trans(
    "imageEditEditor.labelColorContrast",
    {},
    "js"
  ),
  labelColorBrightness: global.Translator.trans(
    "imageEditEditor.labelColorBrightness",
    {},
    "js"
  ),
  labelColorExposure: global.Translator.trans(
    "imageEditEditor.labelColorExposure",
    {},
    "js"
  ),
  labelButtonUtilCrop: global.Translator.trans(
    "imageEditEditor.labelButtonUtilCrop",
    {},
    "js"
  ),
  labelButtonUtilColor: global.Translator.trans(
    "imageEditEditor.labelButtonUtilColor",
    {},
    "js"
  ),
  labelColorSaturation: global.Translator.trans(
    "imageEditEditor.labelColorSaturation",
    {},
    "js"
  ),
  labelButtonCropRotateLeft: global.Translator.trans(
    "imageEditEditor.labelButtonCropRotateLeft",
    {},
    "js"
  ),
  labelButtonCropAspectRatio: global.Translator.trans(
    "imageEditEditor.labelButtonCropAspectRatio",
    {},
    "js"
  ),
  labelButtonConfirm: global.Translator.trans(
    "imageEditEditor.labelButtonConfirm",
    {},
    "js"
  ),
  labelStatusLoadingImage: global.Translator.trans(
    "imageEditEditor.labelStatusLoadingImage",
    {},
    "js"
  ),
  labelButtonCancel: global.Translator.trans(
    "imageEditEditor.labelButtonCancel",
    {},
    "js"
  ),
};

export const FILEPOND_LABELS = {
  labelIdle:
    global.Translator.trans("fileupload.labelIdle.part1", {}, "js") +
    ' <span class="filepond--label-action">' +
    global.Translator.trans("fileupload.labelIdle.part2", {}, "js") +
    "</span>",
  labelInvalidField: global.Translator.trans(
    "fileupload.labelInvalidField",
    {},
    "js"
  ),
  labelFileWaitingForSize: global.Translator.trans(
    "fileupload.labelFileWaitingForSize",
    {},
    "js"
  ),
  labelFileSizeNotAvailable: global.Translator.trans(
    "fileupload.labelFileSizeNotAvailable",
    {},
    "js"
  ),
  labelFileCountSingular: global.Translator.trans(
    "fileupload.labelFileCountSingular",
    {},
    "js"
  ),
  labelFileCountPlural: global.Translator.trans(
    "fileupload.labelFileCountPlural",
    {},
    "js"
  ),
  labelFileLoading: global.Translator.trans(
    "fileupload.labelFileLoading",
    {},
    "js"
  ),
  labelFileAdded: global.Translator.trans(
    "fileupload.labelFileAdded",
    {},
    "js"
  ), // assistive only
  labelFileLoadError: global.Translator.trans(
    "fileupload.labelFileLoadError",
    {},
    "js"
  ),
  labelFileRemoved: global.Translator.trans(
    "fileupload.labelFileRemoved",
    {},
    "js"
  ), // assistive only
  labelFileRemoveError: global.Translator.trans(
    "fileupload.labelFileRemoveError",
    {},
    "js"
  ),
  labelFileProcessing: global.Translator.trans(
    "fileupload.labelFileProcessing",
    {},
    "js"
  ),
  labelFileProcessingComplete: global.Translator.trans(
    "fileupload.labelFileProcessingComplete",
    {},
    "js"
  ),
  labelFileProcessingAborted: global.Translator.trans(
    "fileupload.labelFileProcessingAborted",
    {},
    "js"
  ),
  labelFileProcessingError: global.Translator.trans(
    "fileupload.labelFileProcessingError",
    {},
    "js"
  ),
  labelFileProcessingRevertError: global.Translator.trans(
    "fileupload.labelFileProcessingRevertError",
    {},
    "js"
  ),
  labelTapToCancel: global.Translator.trans(
    "fileupload.labelTapToCancel",
    {},
    "js"
  ),
  labelTapToRetry: global.Translator.trans(
    "fileupload.labelTapToRetry",
    {},
    "js"
  ),
  labelTapToUndo: global.Translator.trans(
    "fileupload.labelTapToUndo",
    {},
    "js"
  ),
  labelButtonRemoveItem: global.Translator.trans(
    "fileupload.labelButtonRemoveItem",
    {},
    "js"
  ),
  labelButtonAbortItemLoad: global.Translator.trans(
    "fileupload.labelButtonAbortItemLoad",
    {},
    "js"
  ),
  labelButtonRetryItemLoad: global.Translator.trans(
    "fileupload.labelButtonRetryItemLoad",
    {},
    "js"
  ),
  labelButtonAbortItemProcessing: global.Translator.trans(
    "fileupload.labelButtonAbortItemProcessing",
    {},
    "js"
  ),
  labelButtonUndoItemProcessing: global.Translator.trans(
    "fileupload.labelButtonUndoItemProcessing",
    {},
    "js"
  ),
  labelButtonRetryItemProcessing: global.Translator.trans(
    "fileupload.labelButtonRetryItemProcessing",
    {},
    "js"
  ),
  labelButtonCropFlipHorizontal: global.Translator.trans(
    "fileupload.labelButtonCropFlipHorizontal",
    {},
    "js"
  ),
  labelButtonCropFlipVertical: global.Translator.trans(
    "fileupload.labelButtonCropFlipVertical",
    {},
    "js"
  ),
  labelButtonProcessItem: global.Translator.trans(
    "fileupload.labelButtonProcessItem",
    {},
    "js"
  ),
};

export const DOKA_EDITOR_CROP_ASPECT_RATIO_OPTIONS = [
  {
    label: global.Translator.trans(
      "imageEditEditor.cropAspectRatioOptions.panorama",
      {},
      "js"
    ),
    value: 0.5,
  },
  {
    label: global.Translator.trans(
      "imageEditEditor.cropAspectRatioOptions.portrait",
      {},
      "js"
    ),
    value: 1.25,
  },
  {
    label: global.Translator.trans(
      "imageEditEditor.cropAspectRatioOptions.landscape",
      {},
      "js"
    ),
    value: 0.7,
  },
  {
    label: global.Translator.trans(
      "imageEditEditor.cropAspectRatioOptions.free",
      {},
      "js"
    ),
    value: null,
  },
];
